import cn from 'classnames';

import styles from './Resume.module.css';
import baseStyle from '../components.module.css';
import Experience from './Experience';
import Education from './Education';
import Coding from './Coding';
import Languages from './Languages';
import Knowledge from './Knowledge';
import { useContext } from 'react';
import LanguageContext from '../context/LanguageContext';
import {
    resumeCoding,
    resumeCodingUA,
    resumeEducation,
    resumeEducationUA,
    resumeExperience,
    resumeExperienceUA,
    resumeKnowledge,
    resumeKnowledgeUA,
    resumeLanguages,
    resumeLanguagesUA,
    resumeSubTitle,
    resumeSubTitleUA,
    resumeTitle,
    resumeTitleUA,
} from '../../data/resume';

export default function Resume({ className, toResumeRef }) {
    const { language } = useContext(LanguageContext);

    return (
        <div className={cn(className, baseStyle.fadeInLeft)} ref={toResumeRef}>
            <div className={baseStyle.topField}></div>
            <h2 className={cn(baseStyle.title)}>
                {language === 'en' ? resumeTitle : resumeTitleUA}
            </h2>
            <div className={cn(styles.resume)}>
                <Experience
                    experienceText={
                        language === 'en'
                            ? resumeExperience
                            : resumeExperienceUA
                    }
                />
                {/* <Education
                    educationText={
                        language === 'en' ? resumeEducation : resumeEducationUA
                    }
                /> */}
                <h3 className={cn(baseStyle.title, styles.skills)}>
                    {language === 'en' ? resumeSubTitle : resumeSubTitleUA}
                </h3>
                <Coding
                    codingText={
                        language === 'en' ? resumeCoding : resumeCodingUA
                    }
                />
                {/* <Languages
                    languageText={
                        language === 'en' ? resumeLanguages : resumeLanguagesUA
                    }
                    language={language}
                /> */}
                {/* <Knowledge
                    knowledgeText={
                        language === 'en' ? resumeKnowledge : resumeKnowledgeUA
                    }
                    language={language}
                /> */}
            </div>
            <div className={baseStyle.bottomField}></div>
        </div>
    );
}
